export const PANEL_ADVANCED_TEMPLATES = [
  {
    style: "standard",
    title: "Add title here",
    icon: "atlaskit/EditorInfoIcon",
    alignment: "left",
    borderRadius: 13,
    hasIcon: true,
    colors: {
      accent: { dark: "#00AFFF", light: "#00AFFF" },
      text: { dark: "#FFFFFF", light: "#FFFFFF" },
    },
  },
  {
    style: "notification",
    title: "Add title here",
    icon: "atlaskit/EditorInfoIcon",
    alignment: "left",
    borderRadius: 13,
    hasIcon: true,
    colors: {
      accent: { dark: "#00AFFF", light: "#00AFFF" },
      text: { dark: "#FFFFFF", light: "#FFFFFF" },
    },
  },
  {
    style: "atlassian",
    title: "Add title here",
    icon: "atlaskit/EditorInfoIcon",
    alignment: "left",
    borderRadius: 13,
    hasIcon: true,
    colors: {
      accent: { dark: "#00AFFF", light: "#00AFFF" },
      text: { dark: "#FFFFFF", light: "#FFFFFF" },
    },
  },
];

export const getPanelAdvancedTemplates = () =>
  PANEL_ADVANCED_TEMPLATES.map((template) => ({
    ...template,
  }));
